import { Heading } from '@findy-code/yuffie/ui/heading';
import { Stack } from '@findy-code/yuffie/ui/stack';
import { Text } from '@findy-code/yuffie/ui/text';

import commonStyles from './styles.module.scss';

export const SectionHeading = ({
  id,
  title,
  comment,
}: {
  id?: string;
  title: string;
  comment?: string;
}) => {
  return (
    <Stack
      align="center"
      className={commonStyles.titleWrapper}
      direction="row"
      justify="space-between"
      spacing={0}
    >
      <Heading
        as="h2"
        className={commonStyles.detailCompanySubTitle}
        font={{
          base: 'heading-l',
          lg: 'heading-xl',
        }}
        id={id}
      >
        {title}
      </Heading>
      {comment && (
        <Text color="onSurfaceMediumEmphasis" font="body4">
          {comment}
        </Text>
      )}
    </Stack>
  );
};
